import { isSerializableObject } from '../types';

function stringifyString(string, prefix) {
  if (!prefix) throw new TypeError('stringify expects an object');
  return "".concat(prefix, "=").concat(encodeURIComponent(string));
}

function stringifyArray(array, prefix) {
  if (!prefix) throw new TypeError('stringify expects an object');
  var ret = [];

  for (var i = 0, l = array.length; i < l; i += 1) {
    ret.push(stringify(array[i], "".concat(prefix, "[").concat(i, "]"))); // eslint-disable-line no-use-before-define
  }

  return ret.join('&');
}

function stringifyObject(object, prefix) {
  var ret = [];
  Object.keys(object).forEach(function (key) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      if (key === '') return;

      if (object[key] == null) {
        ret.push(prefix ? "".concat(prefix, "[").concat(encodeURIComponent(key), "]=") : "".concat(encodeURIComponent(key), "="));
      } else {
        ret.push(stringify(object[key], prefix // eslint-disable-line no-use-before-define
        ? "".concat(prefix, "[").concat(encodeURIComponent(key), "]") : encodeURIComponent(key)));
      }
    }
  });
  return ret.join('&');
}

export default function stringify(object, prefix) {
  if (object === null) {
    return "".concat(prefix || '', "=").concat(encodeURIComponent(String(object)));
  }

  if (Array.isArray(object)) {
    return stringifyArray(object, prefix);
  }

  if (isSerializableObject(object)) {
    return stringifyObject(object, prefix);
  }

  if (typeof object === 'string') {
    return stringifyString(object, prefix);
  }

  return "".concat(prefix || '', "=").concat(encodeURIComponent(String(object)));
}
//# sourceMappingURL=stringify.js.map